import React, { useContext, useEffect, useState } from "react";
import useFetch from "../../Hooks/useFetch";
import { useNavigate, useParams } from "react-router-dom";
import { teamsURL } from "../../Hooks/URL";
import { userContext } from "../../Contexts/userContext";
import AddTeam from "../../Template/Home/Teams/AddTeam/AddTeam";
import useFetchWhen from "../../Hooks/useFetchWhen";

function AddTeamPage({ editType = "" }) {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();
  const params = useParams();

  const [team, setTeam] = useState("");
  const {
    data: teamData,
    loading: teamLoading,
    error: teamError,
  } = useFetchWhen(`${teamsURL}/${params?.id}`, params?.id);

  useEffect(() => {
    if (teamData?.data) setTeam(teamData?.data);
  }, [teamData]);

  const [OpenCoach, setOpenCoach] = useState(false);
  const [OpenMember, setOpenMember] = useState(false);

  return (
    <AddTeam
      OpenCoach={OpenCoach}
      setOpenCoach={setOpenCoach}
      OpenMember={OpenMember}
      setOpenMember={setOpenMember}
      team={team}
      editId={params?.id}
      loading={teamLoading}
      editType={editType}
    />
  );
}

export default AddTeamPage;
